module.exports = __webpack_public_path__ + "img/NL.df8aff15.svg";